import { SxProps, Theme } from '@mui/material';

export const contentCarouselContainerStylesSx: SxProps<Theme> = (theme) => ({
	width: '100%',
	minWidth: '223px',
	minHeight: '150px',
	padding: 0,
	margin: 0,
	boxShadow: 1,
	'& > .content': {
		maxWidth: '1900px',
		margin: '0 auto',
	},
	[theme.breakpoints.down('lg')]: {
		borderRadius: '3px',
	},
	[theme.breakpoints.up('md')]: {
		width: '100vw',
		position: 'relative',
	},
});

export const contentCarouselSkeletonSx: SxProps<Theme> = {
	width: '100%',
	height: '213px',
};
